import styled from 'styled-components';
import {dFlexCenter, dFlex, flexColumn, alignStart, dFlexColumn, alignCenter, justifyEnd} from '../../../globalVariables/GlobalFlex';
import {getFontSize, getFontWeight, getToken, getSpacing} from '@tickchak/react-share/app';
import zIndex from '../../../globalVariables/zIndex';

export const editButtonWrapper = styled.div`
    position: absolute;
    top: 10px;
    inset-inline-start: 15px;
    opacity: 0;
    transition: opacity 200ms ease-in-out;
    z-index: ${zIndex.baseRaised};
`;

export const video = styled.div<{$expended: boolean, $hide: boolean}>`
    ${dFlex}
    ${flexColumn};
    ${alignStart}
    overflow: hidden;
    position: relative;
    padding: ${getSpacing('spaceLg')} ${getSpacing('spaceXl')};
    border-radius: 0;
    border: none;
    background: transparent;
    transition: min-height 300ms ease-in-out, background 300ms ease-in-out;
    cursor: pointer;
    width: 100%;
    
    ${p => !p.$expended && `
        min-height: 52px;
    `}
    
    ${p => p.$expended && `
        min-height: fit-content;
    `}
    
    opacity: ${p => p.$hide ? 0.5 : 1};
    
    &:hover {
        background: var(--TA-color-bg-surface-default);
        ${editButtonWrapper} {
            opacity: 1;
        }
    }
`;

export const videoTitle = styled.div<{$expended?: boolean}>`
    width: 100%;
    text-align: start;
    font-size: ${getFontSize('body')};
    font-weight: ${p => p.$expended ? getFontWeight('bold') : getFontWeight('regular')};
    color: ${getToken('color.text.default')};
    ${dFlex}
    ${alignCenter}
    gap: ${getSpacing('spaceSm')};
    line-height: 20px;
`;

export const arrowIcon = styled.span<{$expended: boolean}>`
    ${dFlexCenter}
    color: ${getToken('color.text.default')};
    width: 16px;
    height: 16px;
    display: ${p => p.$expended ? 'none' : 'flex'};
    margin-inline-start: auto;
    flex-shrink: 0;
`;

export const videoContent = styled.div<{$expended: boolean}>`
    font-size: ${getFontSize('body')};
    font-weight: ${getFontWeight('regular')};
    line-height: ${getToken('typography.lineHeight.body')};
    width: 100%;
    overflow: hidden;
    transition: max-height 300ms ease-in-out, opacity 300ms ease-in-out, padding-top 300ms ease-in-out;
    max-height: ${p => p.$expended ? '1000px' : 0};
    opacity: ${p => p.$expended ? 1 : 0};
    padding-top: ${p => p.$expended ? getSpacing('spaceLg') : 0};
    color: ${getToken('color.text.default')};
    gap: ${getSpacing('spaceLg')};
    text-align: start;
    ${dFlexColumn}
`;

export const descriptionText = styled.p`
    margin: 0;
    font-size: ${getFontSize('body')};
    font-weight: ${getFontWeight('regular')};
    line-height: ${getToken('typography.lineHeight.body')};
    color: ${getToken('color.text.default')};
    text-align: start;
    white-space: pre-wrap;
    margin-bottom: var(--space-Xl);
`;

export const actionButtons = styled.div`
    ${dFlex}
    gap: ${getSpacing('spaceSm')};
    width: 100%;
    > button {
        flex: 1;
        height: 32px;
        border-radius: 100px;
        font-size: var(--font-size-button-category, 14px);
        font-weight: ${getFontWeight('regular')};
        line-height: 16px;
    }
`;

